const DEFAULT_CUSTOMER_PORTAL_URL = 'https://connect.intrum.dev';

interface LocationLike {
  protocol: string;
  host: string;
}

/**
 * Derive the customer portal origin from the current Hub host.
 * Example: hub.intrum.pt -> connect.intrum.pt
 */
export function getCustomerPortalUrl(location?: LocationLike): string {
  const resolvedLocation = location ?? (typeof window !== 'undefined' ? window.location : null);

  if (!resolvedLocation) {
    return DEFAULT_CUSTOMER_PORTAL_URL;
  }

  const { protocol, host } = resolvedLocation;
  if (!host) {
    return DEFAULT_CUSTOMER_PORTAL_URL;
  }

  const portalHost = host.replace(/^hub\./, 'connect.');
  return `${protocol}//${portalHost}`;
}

export function getCustomerPortalLoginUrl(location?: LocationLike): string {
  return `${getCustomerPortalUrl(location)}/login`;
}
